import _ from 'lodash';
export const colorTheme =
    (variables) =>
    ({theme}) =>
        _(variables)
            .map((v, k) => `${k}: ${v[`${theme.type}`]};`)
            .join('\n');

export const themes = {
    DARK: 'dark',
    LIGHT: 'light',
};
